import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TaskDetailsComponent, TaskDialogData } from '../common/task-details.component';

@Component({
  selector: 'app-task-details-dialog-route',
  template: '@if(data){<app-task-details (closeEventEmitter)="close()" [data]="data"></app-task-details>}',
  standalone: true,
  imports: [TaskDetailsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskDetailsDialogComponent {
  static readonly width = '750px';

  constructor(
    public readonly dialogRef: MatDialogRef<TaskDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: TaskDialogData
  ) {}

  close() {
    this.dialogRef.close();
  }
}
